import clsx from 'clsx';
import { useIsWindowScrolling } from '../hooks/useIsWindowScrolling';

const LAUNCHER_SCROLL_IDLE_MS = 800;

type AgentChatLauncherProps = {
  isOpen: boolean;
  onToggle: () => void;
};

const AgentChatLauncher = ({ isOpen, onToggle }: AgentChatLauncherProps) => {
  const isScrolling = useIsWindowScrolling(LAUNCHER_SCROLL_IDLE_MS);
  const isCollapsed = !isOpen && isScrolling;

  return (
    <button
      aria-label={isOpen ? 'Fechar ajuda' : 'Abrir ajuda'}
      className={clsx('agent-chat-widget__launcher position-fixed', {
        'agent-chat-widget__launcher--open': isOpen,
        'agent-chat-widget__launcher--collapsed': isCollapsed,
      })}
      data-testid="agent-chat-fab"
      type="button"
      onClick={onToggle}
    >
      {isOpen ? (
        <i aria-hidden="true" className="bi bi-x-lg fs-2" />
      ) : (
        <>
          <i aria-hidden="true" className="ki-duotone ki-message-question fs-2">
            <span className="path1" />
            <span className="path2" />
            <span className="path3" />
          </i>
          <span className="agent-chat-widget__launcher-label">Ajuda</span>
        </>
      )}
    </button>
  );
};

export default AgentChatLauncher;
